import { useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { availableDomainAtom, resetDomainDataAtom } from '../atoms';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { SITE_PREVIEW_URL } from '../../../consts';

export function useDomainLogic() {
  const { navigate } = useAppNavigation();
  const [availableDomain, setAvailableDomain] = useAtom(availableDomainAtom);
  const resetDomainData = useSetAtom(resetDomainDataAtom);

  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedSuggestion, setSelectedSuggestion] = useState<string>(availableDomain);

  const onSearchChange = (value: string) => {
    setSelectedSuggestion('');
    setSearchValue(value);
  };

  const onSuggestionSelect = (value: string) => {
    setSelectedSuggestion(value);
    setAvailableDomain(value);
  };

  const onContinue = ({ skip }: { skip?: boolean }) => {
    if (skip) {
      resetDomainData();
    }
    navigate(SITE_PREVIEW_URL);
  };

  return {
    onContinue,
    search: {
      value: searchValue,
      onChange: onSearchChange,
    },
    selectedSuggestion: {
      value: selectedSuggestion,
      onSelect: onSuggestionSelect,
    },
  };
}
